import { SMApp, SMUser } from "@/store";
import VueRouter from "vue-router";
import { isReturnableAppPath } from "@/utils/authRoutes";

const LOGIN_PATH = "/auth/login";

export const usePreviousPathSaver = (router: VueRouter) => {
  router.beforeEach((to, from, next) => {
    if (to.path !== LOGIN_PATH) return next();

    let fromPath = from.fullPath || from.path;

    if ((!fromPath || fromPath === "/") && window.location.hash) {
      const hashRoute = window.location.hash.substring(1);

      if (hashRoute && hashRoute !== "/" && !hashRoute.startsWith("/auth/login")) {
        fromPath = hashRoute.startsWith("/") ? hashRoute : `/${hashRoute}`;
      }
    }

    if (!SMApp.previousPath && isReturnableAppPath(fromPath)) {
      SMApp.setPreviousPath(fromPath);
      SMApp.setPreviousUserId(SMUser.user?.ID || 0);
    }

    next();
  });
};
